import classNames from 'classnames';
import CollapsableFolder from 'components/containers/CollapsableMenu/components/CollapsableFolder';
import React, { HTMLAttributes, ReactElement } from 'react';
import classes from './index.module.scss';

export enum MenuItemType {
  Row = 'row',
  Folder = 'folder',
}

export type MenuRow = {
  type: MenuItemType.Row;
  row: ReactElement;
};
export type MenuFolder = {
  type: MenuItemType.Folder;
  title: string;
  subtitle?: string;
  rightText?: string;
  rows: MenuRow[];
};
export type MenuItem = MenuRow | MenuFolder;

interface Props extends HTMLAttributes<HTMLDivElement> {
  items: MenuItem[];
  withItemsCount?: boolean;
}

const CollapsableMenu = ({
  items,
  className,
  withItemsCount = true,
}: Props) => {
  return (
    <div className={classNames(classes.container, className)}>
      {items.map((item, index) => {
        if (item.type === MenuItemType.Folder) {
          return (
            <CollapsableFolder
              key={index.toString()}
              items={item.rows}
              title={item.title}
              subtitle={item.subtitle}
              rightText={item.rightText}
              withItemsCount={withItemsCount}
            />
          );
        } else {
          return (
            <div
              key={index.toString()}
              className={classes.row}
            >
              <>{item.row}</>
            </div>
          );
        }
      })}
    </div>
  );
};

export default CollapsableMenu;
